import { render, staticRenderFns } from "./ControllerForm.vue?vue&type=template&id=cb3cf2da&scoped=true"
import script from "./ControllerForm.vue?vue&type=script&lang=js"
export * from "./ControllerForm.vue?vue&type=script&lang=js"
import style0 from "./ControllerForm.vue?vue&type=style&index=0&id=cb3cf2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3cf2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
